// The guest this device keeps (lib/guestDevice.js), on the home page and the invite page: one tap brings
// the player back to that account, its medal (or initial) and name on the button. Under it, « Nouveau
// profil invité » to make another one, which replaces it.
import React from "react";
import { ChevronRight, Smartphone } from "lucide-react";
import { t } from "../lib/i18n";

export function KnownGuestButton({ guest, onClick, busy }) {
  return (
    <button
      type="button"
      data-testid="guest-resume-btn"
      onClick={onClick}
      disabled={busy}
      className="group w-full flex items-center gap-4 px-4 py-4 cursor-pointer text-start disabled:cursor-wait"
    >
      {guest.picture ? (
        <img src={guest.picture} alt="" className="h-11 w-11 rounded-xl object-cover shrink-0 ring-1 ring-amber-400/30" />
      ) : (
        <div className="h-11 w-11 rounded-xl bg-amber-500/15 flex items-center justify-center shrink-0 text-lg text-amber-300">
          {(guest.name || "?")[0].toUpperCase()}
        </div>
      )}
      <div className="flex-1 min-w-0">
        <div className="truncate text-white text-[15px]">
          {t("landing.resumeAs")} <bdi className="text-amber-300">{guest.name}</bdi>
        </div>
        <div className="mt-0.5 flex items-center gap-1 text-xs text-amber-300/70">
          <Smartphone className="h-3.5 w-3.5 shrink-0" />
          <span>{t("landing.guestKept")}</span>
        </div>
      </div>
      {busy
        ? <span className="h-4 w-4 border-2 border-amber-300/30 border-t-amber-300 rounded-full animate-spin shrink-0" />
        : <ChevronRight className="h-5 w-5 text-amber-400/70 group-hover:text-amber-300 group-hover:translate-x-0.5 transition-all shrink-0 rtl:rotate-180" />}
    </button>
  );
}

// « Nouveau profil invité » under the button, or, once chosen, what it costs and the way back.
export function NewGuestToggle({ guest, open, onToggle }) {
  return (
    <div className="text-center text-xs">
      {open && <p className="mb-1 text-amber-200/80">{t("landing.replaceWarn", { name: guest.name })}</p>}
      <button
        type="button"
        data-testid="new-guest-btn"
        onClick={onToggle}
        className="text-slate-400 underline underline-offset-4 decoration-white/20 hover:text-white transition-colors"
      >
        {open ? t("common.cancel") : t("landing.newGuest")}
      </button>
    </div>
  );
}
